import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttributeDeletionConfirmationComponent } from 'src/app/components/dialog/attributes/attribute-deletion-confirmation/attribute-deletion-confirmation.component';
import { AttributesGroupsActionsComponent } from 'src/app/components/dialog/attributes/attributes-groups-actions/attributes-groups-actions.component';
import { DeletingAttributeGroupComponent } from 'src/app/components/dialog/attributes/deleting-attribute-group/deleting-attribute-group.component';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { NotificationService, DialogModalService, LanguageService, ApiOrganizationsService } from 'src/app/services';
import { ApiAttributesGroupsService } from 'src/app/services/api-attributes-groups.service';

@Component({
  selector: 'app-attributes-groups-list',
  templateUrl: './attributes-groups-list.component.html',
  styleUrls: ['./attributes-groups-list.component.css']
})
export class AttributesGroupsListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  groupsList: any[] = [];
  organizations: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  form: UntypedFormGroup = this.fb.group({
    search: ['']
  })

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiService: ApiAttributesGroupsService,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private apiOrganozations: ApiOrganizationsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      
      this.form.get('search').valueChanges.subscribe(val => {

        this.getList(val)

      })

    );

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getList(searchValue: string = ''): void {

    this.progressRef.start();
    this.loading = true;
    this.groupsList = [];

    this.setListParams(searchValue);

    this.apiService.getList(this.listParams).subscribe((response: Res) => {
      console.log("ATTR_GROUPS_RESPONSE_LIST: ", response)

      if (response.result != null) {

        if(response.result.list != null){

          this.groupsList = response.result.list;

          this.paginationInput = {
            count: response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage: this.listParams.pageNumber,
            size: this.listParams.countOnPage
          }

        }

      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(searchValue): void {

    this.listParams = {
      filter: {
        name: searchValue
      },
      object: 'references',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /**
  * 
  */
  onCreate() {

    let data = {

    }

    this.dialogModal.open(data, AttributesGroupsActionsComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
  * 
  * @param ids 
  */
  onDelete(attrGroupId): void {

    let data = {
      id: [attrGroupId]
    }
    console.log(data);

    this.dialogModal.open(data, DeletingAttributeGroupComponent).then(
      (result) => {

        if (result) {

          this.notification.show('success', 'Данные успешно удалены!');
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  onEdit(id: string) {

    let data = {
      group_id: id
    }

    this.dialogModal.open(data, AttributesGroupsActionsComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  resetSearch() {

    this.form.reset();
    this.getList();
  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.groupsList[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.groupsList.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {
    
    if (this.groupsList.length == 0) return false;

    return this.groupsList.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.groupsList.length;
    let pc = this.groupsList.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.groupsList.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }


}
